import { useEffect, useState, useRef } from "react";
import websocketClient from "../utils/websocketClient";
import axios from "axios";

const useGroupChat = (groupId, userId) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const CLIENT_URL = process.env.REACT_APP_CLIENT_BASE_URL

  const WS_URL = process.env.REACT_APP_WS_BASE_URL;
  const token = localStorage.getItem("access_token");
  const [messages, setMessages] = useState([]);
  const hasLoadedHistory = useRef(false);

  const fetchMessages = async () => {
    if (!groupId || !token) return;

    try {
      const res = await axios.get(`${BASE_URL}/user/chat/group-message-list/`, {
        params: { group_id: groupId },
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
      });
      const messagesArray = res.data.messages || [];

      const formatted = messagesArray
        .map((msg) => ({
          id: msg.id,
          message: msg.message,
          file:msg.file,
          sent_by_me: msg.message_by === "me",
          timestamp: msg.created_at,
          sender: msg.sender,
        }))
        .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

      setMessages(formatted);
    } catch (err) {
      console.error("Failed to fetch group chat history:", err);
    }
  };

  useEffect(() => {
    if (!groupId || !token) return;
    setMessages([]);
    fetchMessages();

    const socketName = `group-${groupId}`;
    const url = `${WS_URL}/ws/group_chat/${groupId}/`;

    websocketClient.connect(socketName, url, token);

    const handleMessage = (data) => {
      if (data.message && data.message.startsWith("Connected to group")) return;

      if (data.messages && !hasLoadedHistory.current) {
        setMessages((prev) => {
          const existingIds = new Set(prev.map((m) => m.id));
          const newMessages = data.messages.filter(
            (m) => !existingIds.has(m.id)
          );
          return [...prev, ...newMessages];
        });
        hasLoadedHistory.current = true;
      } else if (data.message || data.file) {
        if (data.message.startsWith("Connected as")) return;

        const formatted = {
          id: data.id || Date.now(),
          message: data.message,
          file: data.file_data || data.file,  // ← Add file handling
          file_name: data.file_name,          // ← Add file_name
          sent_by_me: data.sender_id === userId ? true : false,
          timestamp: data.timestamp || new Date().toISOString(),
        };

        setMessages((prev) => {
          if (prev.some(m => m.id === formatted.id)) return prev;
          return [...prev, formatted];
        });
      }
    };

    websocketClient.subscribe(socketName, handleMessage);

    return () => {
      websocketClient.unsubscribe(socketName, handleMessage);
      websocketClient.disconnect(socketName);
      hasLoadedHistory.current = false;
    };
  }, [groupId, token]);

  const sendMessage = async (content) => {
    if (!content.trim()) return;
    const socketName = `group-${groupId}`;

    const localMessage = {
      id: Date.now(),
      message: content,
      sent_by_me: true,
      timestamp: new Date().toISOString(),
    };

    setMessages((prev) => [...prev, localMessage]);
    websocketClient.send(socketName, { message: content });
    await fetchMessages();
  };
 const sendFile = async (fileData) => {
    const socketName = `group-${groupId}`;
    const tempId = `temp_file_${Date.now()}`;
    
    // Create a local "uploading" message
    const localFileMessage = {
      file: fileData.file_data, // Base64 preview
      file_name: fileData.file_name,
      sent_by_me: true,
      timestamp: new Date().toISOString(),
      status: 'uploading',
    };
    
    setMessages(prev => [...prev, localFileMessage]);
    
    // Send via WebSocket
    websocketClient.send(socketName, {
      ...fileData,
      type: "file",
      temp_id: tempId,
    });

  //  await fetchMessages();
   setTimeout(() => {
    fetchMessages()
   }, 5000);
  };
  return { messages, sendMessage, setMessages,sendFile };
};

export default useGroupChat;
